import React, { useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { CustomLoader, RoleCard } from './styles';
import { CheckIcon } from '@heroicons/react/outline';
import toast from 'react-hot-toast';

interface IRoleItem {
  uuid: string;
  value: string;
  label: string;
  orgName?: string | null;
  orgId?: string | null;
}

interface ISwitchRoleCompProps {
  allUserRolesList?: IRoleItem[];
  onRoleSelect?(role: any): void;
  onAddRole?(): void;
  title?: string;
  signInToken?: string;
}

export const RoleComp = ({
  allUserRolesList = [],
  signInToken,
  onRoleSelect,
  onAddRole,
  title = 'Select your Role',
}: ISwitchRoleCompProps) => {
  const grouped: Record<
    string,
    { orgName: string | null; roles: IRoleItem[] }
  > = {};
  const ungrouped: IRoleItem[] = [];
  let defaultOpenKey: string | null = null;

  allUserRolesList.forEach((role) => {
    if (role.orgId) {
      if (!grouped[role.orgId]) {
        grouped[role.orgId] = {
          orgName: role.orgName || 'Unknown Org',
          roles: [],
        };
      }
      grouped[role.orgId].roles.push(role);
    } else {
      ungrouped.push(role);
    }
  });

  const [activeKey, setActiveKey] = useState<string | null>(defaultOpenKey);

  const getInitials = (text: string) =>
    text ? text.match(/\b\w/g)?.join('').substring(0, 2).toUpperCase() : '';

  const renderRoleCard = (item: IRoleItem) => {
    return (
      <RoleCard
        key={item.uuid}
        onClick={() => {
          // if (isCurrent) {
          //   toast.error('Please select another Role');
          // } else {
          onRoleSelect?.({
            roleId: item.uuid,
            name: item.value,
            org: item.orgId,
            token: signInToken,
          });
          // }
        }}
        className="d-flex py-3 px-2 my-2 mx-3 rounded align-items-center justify-content-between"
        style={{
          boxShadow: '0px 0px 5px lightgray',
          borderBottom: '1px solid lightgray',
        }}
      >
        <div className="d-flex align-items-center">
          <div
            className="avatar d-flex align-items-center justify-content-center ms-2 fw-bold rounded me-3"
            style={{ backgroundColor: '#104382' }}
          >
            <span style={{ color: 'white' }}>{getInitials(item.label)}</span>
          </div>
          <span style={{ color: 'black' }}>{item.label}</span>
        </div>
      </RoleCard>
    );
  };

  return (
    <Card className="p-3 m-2 shadow">
      <h4 className="mx-3" style={{ color: 'black' }}>
        {title}
      </h4>

      <Accordion
        activeKey={activeKey ?? ''}
        onSelect={(key) => setActiveKey(key || null)}
      >
        {Object.entries(grouped).map(([orgId, { orgName, roles }]) => (
          <Accordion.Item eventKey={orgId} key={orgId}>
            <Accordion.Header>
              <span style={{ color: 'black', fontWeight: 500 }}>{orgName}</span>
            </Accordion.Header>
            <Accordion.Body className="px-2">
              {roles.map((role) => renderRoleCard(role))}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>

      {ungrouped.length > 0 && (
        <>{ungrouped.map((role) => renderRoleCard(role))}</>
      )}

      <RoleCard
        onClick={() => onAddRole?.()}
        className="d-flex py-3 px-2 my-3 mx-3 rounded align-items-center justify-content-between"
        style={{
          boxShadow: '0px 0px 5px lightgray',
          borderBottom: '1px solid lightgray',
        }}
      >
        <div className="d-flex align-items-center">
          <div
            className="avatar d-flex align-items-center justify-content-center ms-2 fw-bold rounded me-3"
            style={{ backgroundColor: '#104382' }}
          >
            <span style={{ color: 'white' }}>{'+'}</span>
          </div>
          <span style={{ color: 'black' }}>{'Add Role'}</span>
        </div>
      </RoleCard>
    </Card>
  );
};

RoleComp.defaultProps = {
  allUserRolesList: [
    {
      id: 'owner',
      label: 'Owner',
    },
    {
      id: 'applicant',
      label: 'Applicant',
    },
  ],
  title: 'Select your Entity/Role',
};
